import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

interface IState {
  isLoggedIn: boolean;
  username: string | undefined;
  email: string | undefined;
}
interface ILoginResult {
  token: string;
  username: string;
  email: string;
}

const Token = Cookies.get("Token");
const Username = Cookies.get("Username");
const Email = Cookies.get("Email");

const initialState: IState = { isLoggedIn: Boolean(Token), username: Username, email: Email };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<ILoginResult>) => {
      Cookies.set("Token", action.payload.token, { expires: 30 });
      Cookies.set("Username", action.payload.username, { expires: 30 });
      Cookies.set("Email", action.payload.email, { expires: 30 });
      return { isLoggedIn: true, username: action.payload.username, email: action.payload.email };
    },
    logout: () => {
      Cookies.remove("Token");
      toast.success("خروج با موفقیت انجام شد");
      return { isLoggedIn: false, username: "", email: "" };
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
